import React from "react";
import { PERSONAL } from "../../data";
import { Button } from "../ui/Button";
import { useScrollTo } from "../../hooks/useScrollTo";

export const Hero: React.FC = () => {
  const { handleAnchorClick } = useScrollTo();

  return (
    <div id="hero">
      {/* ── Left column ── */}
      <div className="hero-left">
        <div className="hero-badge">{PERSONAL.badge}</div>

        <h1 className="hero-h1">
          Don <span className="accent-name">Jayasinghe</span>
        </h1>

        <p className="hero-desc">{PERSONAL.tagline}</p>

        <div className="hero-actions">
          <Button
            variant="primary"
            href="#projects"
            onClick={handleAnchorClick("projects")}
          >
            View Projects
          </Button>

          <Button
            variant="ghost"
            href="#contact"
            onClick={handleAnchorClick("contact")}
          >
            Get in touch
          </Button>

          {/* <img
            src={PHOTO_URI}
            alt="Don Jayasinghe"
            className="hero-profile-photo"
          /> */}
        </div>
      </div>

      {/* ── Right column — info cards ── */}
      <div className="hero-right">
        <div className="hero-card-stack">
          <div className="hc-row">
            <InfoCard
              label="Experience"
              value="4+ Years"
              sub="Full Stack Engineering"
            />
            <InfoCard label="Education" value="M.IT" sub="RMIT University" />
          </div>
          <InfoCard
            label="Primary Stack"
            value="React · TypeScript · Node.js"
            sub="+ AWS, Java, Python, Docker, CI/CD"
          />
          <InfoCard
            label="Location"
            value={PERSONAL.location}
            sub="Open to hybrid & remote opportunities"
          />
        </div>
      </div>
    </div>
  );
};

// ── Sub-component ─────────────────────────────────────────────────────────────
interface InfoCardProps {
  label: string;
  value: string;
  sub: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ label, value, sub }) => (
  <div className="hc">
    <div className="hc-accent" />
    <div className="hc-label">{label}</div>
    <div className="hc-value">{value}</div>
    <div className="hc-sub">{sub}</div>
  </div>
);
